class WheelSizeAPI {
    constructor(apiKey, baseUrl) {
        this.apiKey = apiKey;
        this.baseUrl = baseUrl;
    }

    async fetchData(endpoint, params = {}) {
        try {
            const queryString = new URLSearchParams({
                ...params,
                user_key: this.apiKey
            }).toString();
            
            const url = `${this.baseUrl}/${endpoint}/?${queryString}`;
            console.log('Making API request to:', url); // Debug log

            const response = await fetch(url);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('API Response:', data); // Debug log
            return data;
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
            throw error;
        }
    }

    async getMakes() {
        return this.fetchData('makes');
    }

    async getModels(make) {
        try {
            if (!make) {
                throw new Error('Make parameter is required');
            }
            const response = await this.fetchData('models', { make });
            return response;
        } catch (error) {
            console.error('Error in getModels:', error);
            throw error;
        }
    }

    async getYears(make, model) {
        try {
            if (!make || !model) {
                throw new Error('Make and model parameters are required');
            }
            const response = await this.fetchData('years', { make, model });
            return response;
        } catch (error) {
            console.error('Error in getYears:', error);
            throw error;
        }
    }

    async getModifications(make, model, year) {
        try {
            if (!make || !model || !year) {
                throw new Error('Make, model, and year parameters are required');
            }
            const response = await this.fetchData('modifications', { make, model, year });
            return response;
        } catch (error) {
            console.error('Error in getModifications:', error);
            throw error;
        }
    }

    async getTirePressure(make, model, year, modification) {
        try {
            if (!make || !model || !year || !modification) {
                throw new Error('All parameters are required');
            }
            console.log('getTirePressure params:', { make, model, year, modification }); // Debug log
            return this.fetchData('search/by_model', { make, model, year, modification });
        } catch (error) {
            console.error('Error in getTirePressure:', error);
            throw error;
        }
    }
}

// Initialize the API instance
const api = new WheelSizeAPI(CONFIG.API_KEY, CONFIG.BASE_URL);







